import React, { Component } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs from 'dayjs';


export default class Calendar extends Component {

  // minDate = dayjs().add(2, 'day')
  minDate = dayjs()


  render() {
    const { calendar, onChange } = this.props;
    return (
      <div className = "col-12 col-md-6">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateCalendar
          sx={{margin: 0, width: "100%" }}
          value={calendar}
          onChange={onChange}
          minDate = {this.minDate}
        />
      </LocalizationProvider>
      </div>
    );
  }
}
